import { Component, OnInit } from '@angular/core';
import { VideoService } from "../../shared/video.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-video-detail',
    templateUrl: './video-detail.component.html',
    styleUrls: ['./video-detail.component.scss']
})
export class VideoDetailComponent implements OnInit {
    video = null;

    constructor(private videoService: VideoService, private activatedRoute: ActivatedRoute) {
        this.activatedRoute.params.subscribe((params) => {
            let id = params['id'];
            if (id)
                this.loadVideo(id);
        })
    }

    ngOnInit() {
    }

    loadVideo(id) {
        this.videoService.getVideo(id)
            .then(data => {
                console.log('data: ', data);
                this.video = data;
            })
            .catch(errors => {
                console.log('errors: ', errors);
            })
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/gallery/video-detail/video-detail.component.ts